(function () {
    'use strict';

    angular.module('AngularAdmin')

        .factory('MixDesignSvc', ['$http', function ($http) {


            var mixDesignSvc = {
                loadAll: function (plant_id) {
                    var url = `/plant/${plant_id}/mix_designs/`;

                    return $http.get(url, {});
                },
                listToIdMap: function (list) {
                    var map = {};
                    for (var i = list.length - 1; i >= 0; i--) {
                        map[list[i].output_material] = list[i];
                    }
                    return map;
                },
                create: function (mix_design, plant_id) {
                    var url = String.format('/plant/{0}/mix_design/new/', plant_id, mix_design.id);
                    return $http({
                        method: 'POST',
                        url: url,
                        data: mix_design
                    });
                },
                update: function (mix_design, plant_id) {
                    var url = String.format('/plant/{0}/mix_design/{1}/', plant_id, mix_design.id);
                    return $http({
                        method: 'PUT',
                        url: url,
                        data: mix_design
                    })
                },
                delete: function (mix_design_id, plant_id) {
                    var url = String.format('/plant/{0}/mix_design/{1}/delete/', plant_id, mix_design_id);
                    return $http({
                        method: 'DELETE',
                        url: url
                    });
                }
            };

            return mixDesignSvc;
        }]);

})();